export function reportError(e) {
    try {
        console.error(e);
        window.Raven && window.Raven.captureException(e);
    } catch(e2) {
        console.error(e2);
    }
}